import { Link } from 'react-router-dom';

export default function Footer() {
  const services = [
    'Thyroid & Adrenal Solutions',
    'Bio-Identical Hormone Therapy',
    'Chelation & IV Therapy',
    'Psychiatric Alternatives',
    'Sleep Solutions',
    'Weight Loss Programs',
    'Specialized Testing',
    'Total Health Makeover',
    'Women\'s & Men\'s Wellness',
    'Medical Marijuana Certification',
  ];

  return (
    <footer className="bg-white border-t border-teal-100 text-teal-900">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://storage.readdy-site.link/project_files/3236bba1-19d1-4b50-b72d-8ce744c77a64/988a6fa3-2231-4724-b521-293e258ee7f0_betteralternativelogo.png?v=d535279da15a85e83647673b64272d19"
              alt="A Better Alternative Medical Center"
              className="h-12 w-auto block mb-5"
              style={{ border: 'none', outline: 'none', boxShadow: 'none' }}
            />
            <p className="text-teal-600 text-sm leading-relaxed mb-5">
              Hackensack, NJ's trusted functional medicine practice for over 40 years. Root-cause care, integrative treatments, and whole-person wellness.
            </p>
            <div className="flex gap-3">
              <a
                href="http://facebook.com/altmedicalcenter"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center bg-teal-50 hover:bg-teal-100 rounded-md transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-teal-700 text-base"></i>
              </a>
              <a
                href="https://www.linkedin.com/in/robin-ellen-leder-md-9380a9317/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center bg-teal-50 hover:bg-teal-100 rounded-md transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-teal-700 text-base"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-teal-900 text-sm tracking-widest uppercase mb-5">Our Services</h4>
            <ul className="space-y-2">
              {services.map((s) => (
                <li key={s}>
                  <Link
                    to="/services"
                    className="text-teal-600 hover:text-teal-900 text-sm transition-colors cursor-pointer flex items-center gap-2"
                  >
                    <span className="w-1 h-1 rounded-full bg-teal-400 inline-block flex-shrink-0"></span>
                    {s}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact NAP */}
          <div>
            <h4 className="font-semibold text-teal-900 text-sm tracking-widest uppercase mb-5">Contact &amp; Hours</h4>
            <div className="space-y-4 text-sm">
              <div className="flex items-start gap-3">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-teal-500 text-base"></i>
                </div>
                <address className="not-italic text-teal-600 leading-relaxed">
                  A Better Alternative Medical Center<br />
                  235 Prospect Avenue, Suite LB<br />
                  Hackensack, NJ 07601
                </address>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-teal-500 text-base"></i>
                </div>
                <div>
                  <a href="tel:2015251155" className="text-teal-700 hover:text-teal-900 transition-colors cursor-pointer">(201) 525-1155</a>
                  <span className="text-teal-400 text-xs ml-2">Tue / Thu / Sat</span>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-teal-500 text-base"></i>
                </div>
                <div>
                  <a href="tel:5512988799" className="text-teal-700 hover:text-teal-900 transition-colors cursor-pointer">(551) 298-8799</a>
                  <span className="text-teal-400 text-xs ml-2">Sun / Mon / Wed / Fri</span>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-teal-500 text-base"></i>
                </div>
                <a href="mailto:a.better.alternative.medical@gmail.com" className="text-teal-600 hover:text-teal-900 transition-colors cursor-pointer text-xs break-all">
                  a.better.alternative.medical@gmail.com
                </a>
              </div>
            </div>
          </div>

          {/* Service Areas */}
          <div>
            <h4 className="font-semibold text-teal-900 text-sm tracking-widest uppercase mb-5">Service Areas</h4>
            <p className="text-teal-600 text-xs leading-relaxed mb-3">
              Serving patients across Bergen County and the greater New York tri-state area:
            </p>
            <div className="flex flex-wrap gap-1.5">
              {[
                'Hackensack','Paramus','Teaneck','Englewood','Fort Lee',
                'Ridgewood','Tenafly','Fair Lawn','Bergenfield','Mahwah',
                'Hoboken','Jersey City','NYC'
              ].map((city) => (
                <span key={city} className="bg-teal-50 text-teal-700 text-xs px-2 py-1 rounded border border-teal-100">
                  {city}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-teal-100">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-5 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-teal-500 text-xs">
            &copy; 2026 Dr. Robin Ellen Leder, MD – A Better Alternative Medical Center. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="text-teal-500 hover:text-teal-800 text-xs transition-colors cursor-pointer">About</Link>
            <Link to="/services" className="text-teal-500 hover:text-teal-800 text-xs transition-colors cursor-pointer">Services</Link>
            <Link to="/contact" className="text-teal-500 hover:text-teal-800 text-xs transition-colors cursor-pointer">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
